
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.4 28.007c-1.5-17.2-23.2-23.1-33-9.5v-5.5c0-.4-.1-1.6-.7-1.6s-.7 1.2-.7 1.6v8.7c0 .4.1 1.6.7 1.6h8.7c1 0 1-3.2 0-3.2H16c8-9.1 24.1-8.3 29 4.3 3 7.7-1.1 16.2-8.3 19.7-7 3.4-15.1 1.5-20.4-4-.9-.9-1.3 2.1-.7 2.7 12.6 13 33.3 2.8 31.8-14.8z"}})])
          )
        }
      }
    